import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

export const auth = {
  namespaced: true,
  state: {
    token: '',
    user: {},
    config: {},
    permissions: {},
    modules: {}
  },
  actions,
  getters,
  mutations
};
